<template>
  <div id="contenedor-editar-contratista">
    <v-form
      v-model="formularioValido"
      ref="editarContratista">
      <v-card>
        <v-card-title class="secondary--text">
          Editar contratista
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              cols="12"
              sm="6"
              md="4"
              v-model="contratista.rfc"
              label="RFC"
              v-on:keypress.enter="mixActualizarContratista"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="6"
              md="5"
              v-model="contratista.nombreRazonSocial"
              label="Nombre Razon Social"
              v-on:keypress.enter="mixActualizarContratista"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="3"
              md="3"
              v-model="contratista.nacionalidad"
              label="Nacionalidad"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="7"
              md="4"
              v-model="contratista.calle"
              label="Calle"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="6"
              sm="2"
              v-model="contratista.numero"
              label="#"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="6"
              sm="4"
              md="3"
              v-model="contratista.colonia"
              label="Colonia"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="6"
              sm="4"
              md="3"
              v-model.number="contratista.codigoPostal"
              label="CP"
              v-on:keypress.enter="mixActualizarContratista"
              type="number"
              :rules="[mixReglas.codigoPostal]">
            </custom-text-field>
            <custom-text-field
              cols="6"
              sm="4"
              md="4"
              v-model="contratista.entidad"
              label="Entidad"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="4"
              md="4"
              v-model="contratista.municipio"
              label="Municipio"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="8"
              md="4"
              v-model="contratista.nombreRepresentante"
              label="Nombre Representante"
              v-on:keypress.enter="mixActualizarContratista">
            </custom-text-field>
            <custom-text-field
              cols="12"
              sm="6"
              md="4"
              v-model="contratista.correoElectronico"
              label="Correo"
              v-on:keypress.enter="mixActualizarContratista"
              :rules="[mixReglas.requerido, mixReglas.email]">
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratista"
            tipo="formAceptar"
            label="Actualizar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoContratistas from './mixCatalogoContratistas';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ActualizarContratista',
  mixins: [mixCatalogoContratistas],
  components: {
    CustomTextField,
    CustomButton,
  },
  props: {
    contratistaEditar: Object,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      test: '',
      contratista: {
        // idCliente: 'a98aa86a-b3ff-41de-9a2b-c8c7d6f9be27',
        id: this.contratistaEditar.id,
        rfc: this.contratistaEditar.rfc,
        nombreRazonSocial: this.contratistaEditar.nombreRazonSocial,
        nacionalidad: this.contratistaEditar.nacionalidad,
        calle: this.contratistaEditar.calle,
        numero: this.contratistaEditar.numero,
        colonia: this.contratistaEditar.colonia,
        codigoPostal: this.contratistaEditar.codigoPostal,
        entidad: this.contratistaEditar.entidad,
        municipio: this.contratistaEditar.municipio,
        nombreRepresentante: this.contratistaEditar.nombreRepresentante,
        correoElectronico: this.contratistaEditar.correoElectronico,
        favorito: this.contratistaEditar.favorito,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarContratista.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
